import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-3/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { SENDING_REQUEST, REQUEST_ERROR, REQUEST_SUCCESS, CLEAR_ERROR, LOADING } from '../actions/constants';

// The initial application state
let initialState = {
  error: '',
  success: '',
  currentlySending: false,
  loading: false
};

// Takes care of changing the application state
const requests = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SENDING_REQUEST:
      return _objectSpread({}, state, {
        currentlySending: action.sending
      });
    case REQUEST_ERROR:
      return _objectSpread({}, state, {
        error: action.error
      });
    case REQUEST_SUCCESS:
      return _objectSpread({}, state, {
        success: action.success
      });
    case CLEAR_ERROR:
      return _objectSpread({}, state, {
        error: ''
      });
    case LOADING:
      return _objectSpread({}, state, {
        loading: action.payload
      });
    default:
      return state;
  }
};
export default requests;